import React, { useState } from 'react';

function ColorPalette() {
  const [selectedColor, setSelectedColor] = useState(null);

  const colors = [
    { hex: '#e8ddb5', name: 'Pale Banana' },
    { hex: '#c5dde8', name: 'Skyway' },
    { hex: '#d9e4c7', name: 'Seedling' },
    { hex: '#f4c2c2', name: 'Rose Quartz' },
  ];

  //Previous   const colors = [
  //   { hex: '#f9f4e8', name: 'Calla Lily' },
  //   { hex: '#d4e5d8', name: 'Fresh Breeze' },
  //   { hex: '#9db5a1', name: 'Verdant' },
  //   { hex: '#7a8b6f', name: 'Breath of Spring' },
  //   { hex: '#f4b8a0', name: 'Anthurium' },
  //   { hex: '#f5db94', name: 'Lemon Drop' }
  // ];

  return (
    <div className="palette-section">
      <h3>Our Wedding Colors</h3>
      <div className="color-palette">
        {colors.map((color, index) => (
          <div
            key={index}
            className="color-swatch"
            style={{ background: color.hex, cursor: 'pointer' }}
            title={color.name}
            onClick={() => setSelectedColor(color.name)}
          />
        ))}
      </div>
      {selectedColor && <p style={{ textAlign: 'center', color: '#6b8e6f', marginTop: '1rem', fontSize: '1.1rem' }}>{selectedColor}</p>}
    </div>
  );
}

export default ColorPalette;
